import React from 'react';
import {books} from '../../content/books/books';
import BookSpotlight from './BookSpotlight';
import './NextBookSection.css';

export default function NextBookSection() {
  const nextBook = books.find((b) => b.isNext);
  if (!nextBook) return null;

  return (
    <div className='nextBookSection book-section'>
      <BookSpotlight
        book={nextBook}
        variant='next'
      />
    </div>
  );
}
